import { Component } from 'react'
import * as styles from 'components/features/pfm/AccomplishmentModal/AccomplishmentModal.css'
import Popup from 'components/features/pfm/Popup/Popup'
import Button from 'components/features/pfm/Button/Button'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'

export type AccomplishmentModalStateProps = {
}

export type AccomplishmentModalDispatchProps = {
  onCloseButtonClick: () => void
}

type AccomplishmentModalProps = AccomplishmentModalDispatchProps & AccomplishmentModalStateProps

class AccomplishmentModal extends Component<AccomplishmentModalProps> {
  render () {
    const { onCloseButtonClick } = this.props

    return (
      <Popup onCloseButtonClick={ onCloseButtonClick }>
        <div className={ styles.content }>
          <div className={ styles.iconWrapper }>
            <img src='/images/golden-cup.svg' alt='Rewards' className={ styles.icon } />
          </div>
          <div className={ styles.title }>
            We started tracking your reward!
          </div>
          <div className={ styles.text }>
            See it on your Rewards page.
          </div>
          { this.renderRewardsButton() }
          { this.renderCloseButton() }
        </div>
      </Popup>
    )
  }

  renderRewardsButton () {
    return (
      <NavigationLink to='rewards_summary' onClick={ this.props.onCloseButtonClick }>
        <div className={ styles.buttonWrapper }>
          <Button fullWidth>
            See Your Rewards
          </Button>
        </div>
      </NavigationLink>
    )
  }

  renderCloseButton () {
    return (
      <div className={ styles.closeButtonWrapper }>
        <Button
          style='outlined'
          fullWidth
          onClick={ this.props.onCloseButtonClick }
        >
          Close
        </Button>
      </div>
    )
  }
}

export default AccomplishmentModal
